import React from 'react'
import { Container } from '@material-ui/core'
import { FormattedMessage } from 'react-intl'
import InvoiceSteps from '../Steps'
import { useStyles } from './Styles'
import PageTitle from '../../PageTitle'

const CreateInvoiceContent = () => {
  const classes = useStyles()
  return (
    <>
      <Container maxWidth="xl" className={classes.InvoiceCreateWrapper}>
        <PageTitle
          title={<FormattedMessage id='Invoice.Create.PageTitle'/>}
          invoice
        />
        <InvoiceSteps/>
      </Container>
    </>
  )
}

export default CreateInvoiceContent
